module.exports = "<div class=\"fiIconsGroup\">\n    <div class=\"cardIconsGroup\">\n        <div class=\"icons\" ng-repeat=\"cardType in cardTypes.allowed track by $index\">\n            <div class = \"cardIcon {{cardType}}\"></div>\n        </div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-wallet-components/src/fi-logos/template.html
// module id = ../node_modules/xo-wallet-components/src/fi-logos/template.html
// module chunks = 0